import Swiper, {Autoplay, Navigation, Pagination} from "swiper";

export default {
  init() {
    /* eslint-disable no-unused-vars */
    require('es6-object-assign').polyfill();

    $(document).on('click', '.archives-wrap a', function (e) {
      e.preventDefault();
    });

    $(document).on('click', '#archive-load-more', function (e) {
      e.preventDefault();
      let button = $(this);
      let next = button.data('next');
      let max = button.data('max');
      let per_page = button.data('per_page');

      let archivesWrap = $('.archives');
      let loadMoreWrap = $('#archive-load-more-wrap');

      $.ajax({
        type: "POST",
        url: '/wp-json/xyi/api/load-more-archives/',
        data: {
          'next': next,
          'max': max,
          'per_page': per_page,
        },
        encoded: true,
        beforeSend: function () {
        },
        complete: function (data) {
        },
      }).done(function (data) {
      }).success(function (data) {
        archivesWrap.append(data.content)
        button.data('next', data.next);
        if (data.next > max) {
          loadMoreWrap.hide();
          $('body').addClass('no-more');
        }
        initArchiveSliders(data.additional_class)

        var firstElement = $('.' + data.additional_class).first();
        if (firstElement.length > 0) {
          var scrollTopPos = firstElement.offset().top;
          $('html, body').animate({ scrollTop: scrollTopPos }, 500);
        }
      });

    });

    initArchiveSliders();

    function initArchiveSliders(additional_class = false) {
      let simpleClass = '.archive-slider';
      let reverseClass = '.archive-slider-r';

      if (additional_class) {
        simpleClass += '.' + additional_class;
        reverseClass += '.' + additional_class;
      }

      // Initialize swiper
      var swiper = new Swiper(simpleClass, {
        loop: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        slidesPerView: 'auto',
        speed: 3500,
        grabCursor: false,
        allowTouchMove: false,
        mousewheelControl: false,
        keyboardControl: false,
        modules: [Autoplay, Navigation, Pagination],
      });

      // Initialize swiper_r
      var swiper_r = new Swiper(reverseClass, {
        loop: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
          reverseDirection: true,
        },
        slidesPerView: 'auto',
        speed: 4500,
        grabCursor: false,
        allowTouchMove: false,
        mousewheelControl: false,
        keyboardControl: false,
        modules: [Autoplay, Navigation, Pagination],
      });
    }

  },
}



// WEBPACK FOOTER //
// ./scripts/routes/archive.js